var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"099aefbd61a2c74ba85e5a84f8c3504176a64f1c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-react@farmec-sa"]={id:"099aefbd61a2c74ba85e5a84f8c3504176a64f1c"};
      